var map = {
	"./Classifier.mp4": 276,
	"./body_detectin_video.mp4": 277,
	"./celebrities_landmarks.mp4": 278,
	"./chinese_text_analyze_demo.mov": 279,
	"./face_detection_video.mp4": 280,
	"./face_landmarks_video.mp4": 281,
	"./face_verification_video.mp4": 282,
	"./gesture_recognition_video.mp4": 283,
	"./language_class_video.mp4": 284,
	"./language_understand_video.mp4": 285,
	"./machine_learning.mp4": 286,
	"./picture_analyze_video.mp4": 287,
	"./print&writing_recog_video.mp4": 288,
	"./text_analyze_video.mp4": 289,
	"./text_understand_video.mp4": 290,
	"./tone_analyze_video.mp4": 291,
	"./writing_recog_demo.mp4": 292
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 275;